"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = Birthday;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function Birthday(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    width: 100,
    height: 100
  }, props), /*#__PURE__*/_react["default"].createElement("g", {
    id: "General"
  }, /*#__PURE__*/_react["default"].createElement("g", {
    id: "birthday"
  }, /*#__PURE__*/_react["default"].createElement("g", {
    id: "outline-4",
    "data-name": "outline"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M80.083,48.031H72.74V37.375a2.5,2.5,0,0,0-5,0V48.031H52.5V27.255a2.5,2.5,0,1,0-5,0V48.031H32.26V37.375a2.5,2.5,0,1,0-5,0V48.031H19.917a7.509,7.509,0,0,0-7.5,7.5V90a2.5,2.5,0,0,0,2.5,2.5H85.083a2.5,2.5,0,0,0,2.5-2.5V55.531A7.509,7.509,0,0,0,80.083,48.031Zm-60.166,5H80.083a2.5,2.5,0,0,1,2.5,2.5v4.258c-5.367-.266-7.92.728-14.986,3.493-2.28.892-5.117,2-8.721,3.33-9.593,3.538-13.4,1.435-18.66-1.477a40.322,40.322,0,0,0-8.758-3.893c-6.48-1.851-11.1-.588-14.041,1.046V55.531A2.5,2.5,0,0,1,19.917,53.031ZM17.417,87.5V68.608c.022-.028.05-.05.071-.08.037-.049,3.753-5,12.6-2.479a35.7,35.7,0,0,1,7.71,3.462c3.513,1.942,7.1,3.928,12.362,3.928A30.2,30.2,0,0,0,60.606,71.3c3.65-1.347,6.512-2.466,8.812-3.366,6.866-2.685,8.7-3.4,13.165-3.144V87.5Z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M28.664,32.7c.1,0,.166-.005.2-.008,1.874.066,3.15-.474,3.745-1.575,1.814-3.354-3.365-10.825-3.586-11.141a.25.25,0,0,0-.451.185c.087.508-.229,5.542-1.085,7.267C26.456,29.5,26.25,31,26.873,31.893A2.166,2.166,0,0,0,28.664,32.7Z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M48.9,22.581c.1,0,.166,0,.2-.008,1.918.072,3.15-.474,3.746-1.576,1.813-3.354-3.366-10.824-3.586-11.141a.254.254,0,0,0-.3-.087.248.248,0,0,0-.15.274c.087.507-.227,5.538-1.085,7.266-1.03,2.071-1.236,3.573-.614,4.462A2.165,2.165,0,0,0,48.9,22.581Z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M69.019,32.7c.095,0,.166-.005.2-.008,1.869.054,3.149-.474,3.745-1.575,1.813-3.354-3.366-10.825-3.587-11.141a.25.25,0,0,0-.451.186c.088.507-.227,5.537-1.084,7.266C66.811,29.5,66.6,31,67.228,31.893A2.163,2.163,0,0,0,69.019,32.7Z"
  })))));
}